import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { withFormik } from 'formik';
import { Row, Col } from 'react-bootstrap';
import _isEmpty from 'lodash/isEmpty';
import { PaymentCard, GiftItem} from 'components/gifts-table';
import { Card, PaymentFlowLayout, Back } from 'components';
import { withStore } from 'store';
import { withLayout } from 'hocs';
import { updateVariantIdIfChanged } from 'util/giftTable';
import { mapPropsToValues as mapGiftsProductsToValues } from 'components/gifts-table/GiftsList/config';
import { fetchGiftTableInfo } from 'store/actions/giftTable';
import { showErrorResponseModal } from 'store/actions/commons';
import {
  fetchExternalGiftTableProducts,
  addShoppingCartProduct,
  removeShoppingCartProduct,
  resetExternalGiftTable,
  fetchShoppingCart,
} from 'store/actions/externalGiftTable';

import { useWindowSize } from 'hooks';


function BuyGifts({ dispatch, tableInfo, shoppingCartProducts = [] }) {
  const history = useHistory();
  const { tableId } = useParams();
  const [, { isMobile }] = useWindowSize();
  const handleAddProduct = async (product) => {
    const response = await dispatch(addShoppingCartProduct(product));
    !response && dispatch(fetchShoppingCart({ tableId: tableInfo.id }));
    !response && dispatch(showErrorResponseModal('Intenta más tarde'));
    return response;
  }

  const handleDeleteProduct = async (product) => {
    const response = await dispatch(removeShoppingCartProduct(product));
    !response && dispatch(fetchShoppingCart({ tableId: tableInfo.id }));
    !response && dispatch(showErrorResponseModal('Intenta más tarde'));
    return response;
  };

  const handleClickPayNow = () => {
    history.push(`/payment-flow/${tableInfo.id}/steps-flow`);
  };
  

  useEffect(() => {
    if (tableId)
      dispatch(fetchGiftTableInfo({ id: tableId, isExternal: true }));
  }, [tableId]);

  useEffect(() => {
    if (!_isEmpty(tableInfo)) {
      dispatch(fetchExternalGiftTableProducts(tableInfo));
    }
  }, [tableInfo]);

  useEffect(async () => {
    const params = {
      table_id: tableInfo.id,
      product_id: 'id',
      variant_id: 'variant_sears_id',
      children_sku: 'children_sku_sears',
    }
    await updateVariantIdIfChanged(shoppingCartProducts, params);
  }, [shoppingCartProducts]);


  useEffect(() => () => dispatch(resetExternalGiftTable()), []);

  

  return (
    <PaymentFlowLayout titleBack='Comprar regalo'>
      <Row className={!isMobile?'pt-4':''}>
        <Col lg={8} className="mb-0">
          <Card bodyClassName='px-0 m-0' contentClassName="m-0" className={isMobile?'border-0 mt-0':''}>
            <Row className="p-0 m-0">
              {shoppingCartProducts?.map((product) => {
                const quantityForGift = tableInfo.gifts.find(
                  (x) => x.product_id === product.id
                )?.quantity_for_gift;

                const amount = tableInfo.gifts.find(
                  (x) => x.product_id === product.id
                )?.amount;
                const validation = amount < quantityForGift;
                return (
                  <Col key={product.id} xs={12} className={!isMobile?'p-0 m-0':'px-0'}>
                    <GiftItem
                      onAddGift={handleAddProduct}
                      onUpdateGift={handleAddProduct}
                      onDeleteGift={handleDeleteProduct}
                      item={{
                        ...product,
                        stock: validation ? amount : quantityForGift,
                      }}
                      id={product.id}
                      type={!isMobile?'big':'list'}
                      mode="guest"
                      selected
                      quantity={product.quantity}
                      className="border-0"
                      bigRenderClassName="justify-content-around"
                      callFrom = {isMobile?'CartProductsMobile':''}
                    />
                  </Col>
                );
              })}
            </Row>
          </Card>
        </Col>
        <Col lg={4} className="d-flex justify-content-center mb-1">
          <PaymentCard onClickPayNow={handleClickPayNow} />
        </Col>
      </Row>
    </PaymentFlowLayout>
  );
}

const mapPropsToValues = ({ shoppingCartProducts }) =>
  mapGiftsProductsToValues({
    data: { results: { list: shoppingCartProducts } },
  });

export default withLayout(
  withStore({
    mapStateToProps: (state) => ({
      tableInfo: state.externalGiftTable.giftTableInfo.data,
      shoppingCartProducts: state.externalGiftTable.shoppingCartProducts.data,
    }),
  })(withFormik({ mapPropsToValues })(BuyGifts))
);
